const responsiveToggle = (theToggle) => {
  const focusTrap = (element, removeButton) => {
    const focusable = 'button, a:not(.skiplink), input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const focusableElements = element.querySelectorAll( focusable );
    const firstFocusableElement = focusableElements[1];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    firstFocusableElement.focus();

    const shutdownFocusTrap = () => {
      closeMenu( theToggle )
      element.removeEventListener( 'keydown', handleKeydown );
      removeButton.removeEventListener( 'click', shutdownFocusTrap );
      removeButton.focus();
    };

    removeButton.addEventListener( 'click', shutdownFocusTrap );

    const handleKeydown = (event) => {
      const isEscPressed = (event.key === 'Escape');
      const isTabPressed = (event.key === 'Tab' || event.keyCode === 9);

      if (isEscPressed) {
        shutdownFocusTrap();
      }

      if (!isTabPressed) {
        return;
      }

      if (event.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          event.preventDefault();
          lastFocusableElement.focus();
        }
        return;
      }

      if (document.activeElement === lastFocusableElement) {
        event.preventDefault();
        firstFocusableElement.focus();
      }
    };

    element.addEventListener( 'keydown', handleKeydown );
  }

  const openMenu = (toggle) => {
    toggle.setAttribute( 'aria-expanded', true )
    toggle.setAttribute( 'aria-label', 'Close menu navigation' )
    toggle.querySelector('.open').style.display = 'none';
    toggle.querySelector('.close').style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  const closeMenu = (toggle) => {
    toggle.setAttribute( 'aria-expanded', false )
    toggle.setAttribute( 'aria-label', 'Open menu navigation' )
    toggle.querySelector('.close').style.display = 'none';
    toggle.querySelector('.open').style.display = 'block';
    document.body.style.overflow = 'auto';
  }

  theToggle.addEventListener( 'click', (_) => {
    const navigationMenu = document.querySelector( '.header__nav' );
    const ctaMenu = document.querySelector( '.header__ctas' );

    navigationMenu.classList.toggle( 'show' )
    navigationMenu.classList.contains( 'show' ) ? openMenu( theToggle ) : closeMenu( theToggle )

    if (navigationMenu.classList.contains( 'show' )) {
      focusTrap( document.querySelector('header[role="banner"] .container'), theToggle );
    }

    ctaMenu.classList.toggle( 'show' )
  } )
}

export default responsiveToggle
